import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import "./AdminTransactions.css";

function Adminchekibonus() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [approvedCount, setApprovedCount] = useState(0);
  const [todayAmounts, setTodayAmounts] = useState({});
  const [todayReferrers, setTodayReferrers] = useState({});

  useEffect(() => {
    const fetchAllTransactions = async () => {
      setLoading(true);
      try {
        const tshSnap = await getDocs(collection(db, "tsh_transactions"));
        const usdtSnap = await getDocs(collection(db, "usdt_transactions"));

        const combined = [
          ...tshSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            collection: "tsh_transactions",
          })),
          ...usdtSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            collection: "usdt_transactions",
          })),
        ];

        combined.sort((a, b) => {
          const aTime = a.timestamp?.seconds || 0;
          const bTime = b.timestamp?.seconds || 0;
          return bTime - aTime;
        });

        setTransactions(combined);

        // Hesabu approved count
        const totalApproved = combined.filter((tx) => tx.status === "success").length;
        setApprovedCount(totalApproved);

        // Hesabu miamala ya leo
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const todayOnly = combined.filter((tx) => {
          const txDate = tx.timestamp?.seconds
            ? new Date(tx.timestamp.seconds * 1000)
            : null;
          return txDate && txDate >= today && tx.status === "success";
        });

        const totalPerUserToday = todayOnly.reduce((acc, tx) => {
          const username = tx.username || "Unknown";
          const amount = Number(tx.amount || 0);
          acc[username] = (acc[username] || 0) + amount;
          return acc;
        }, {});
        setTodayAmounts(totalPerUserToday);

        // Pata referrers
        const usernamesToday = Object.keys(totalPerUserToday);
        const batchSize = 10;

        const referrersMap = {};
        for (let i = 0; i < usernamesToday.length; i += batchSize) {
          const batch = usernamesToday.slice(i, i + batchSize);
          const usersQuery = query(
            collection(db, "users"),
            where("username", "in", batch)
          );
          const usersSnap = await getDocs(usersQuery);
          usersSnap.docs.forEach((d) => {
            const data = d.data();
            referrersMap[data.username] = data.referralBy || null;
          });
          batch.forEach((u) => {
            if (referrersMap[u] === undefined) referrersMap[u] = null;
          });
        }

        const referralValues = [
          ...new Set(
            Object.values(referrersMap).filter((v) => v !== null && v !== "")
          ),
        ];

        const resolvedByUsername = {};
        const unresolvedValues = new Set(referralValues);

        for (let i = 0; i < referralValues.length; i += batchSize) {
          const batch = referralValues.slice(i, i + batchSize);
          const q = query(collection(db, "users"), where("username", "in", batch));
          const snap = await getDocs(q);
          snap.docs.forEach((d) => {
            const data = d.data();
            if (data.username) {
              resolvedByUsername[data.username] = data.username;
              unresolvedValues.delete(data.username);
            }
          });
        }

        const codeToUsername = {};
        const unresolvedList = Array.from(unresolvedValues);
        if (unresolvedList.length > 0) {
          for (let i = 0; i < unresolvedList.length; i += batchSize) {
            const batch = unresolvedList.slice(i, i + batchSize);
            const q = query(
              collection(db, "users"),
              where("referralCode", "in", batch)
            );
            const snap = await getDocs(q);
            snap.docs.forEach((d) => {
              const data = d.data();
              if (data.referralCode && data.username) {
                codeToUsername[data.referralCode] = data.username;
                unresolvedValues.delete(data.referralCode);
              }
            });
          }
        }

        const finalReferrers = {};
        Object.entries(referrersMap).forEach(([username, refVal]) => {
          if (!refVal) {
            finalReferrers[username] = "Hakuna";
            return;
          }
          if (resolvedByUsername[refVal]) {
            finalReferrers[username] = resolvedByUsername[refVal];
            return;
          }
          if (codeToUsername[refVal]) {
            finalReferrers[username] = codeToUsername[refVal];
            return;
          }
          finalReferrers[username] = "Haijulikani";
        });

        setTodayReferrers(finalReferrers);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllTransactions();
  }, []);

  return (
    <div className="admin-transactions-container">
      <h2>Admin - Miamala</h2>
      {loading ? (
        <p>Inapakia...</p>
      ) : (
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          {/* Box ya miamala ya leo */}
          <div
            style={{
              flex: "1",
              background: "#111",
              padding: "15px",
              borderRadius: "10px",
              maxWidth: "350px",
              color: "#fff",
            }}
          >
            <h3 style={{ color: "#00ff99" }}>Miamala ya Leo</h3>
            {Object.keys(todayAmounts).length === 0 ? (
              <p style={{ color: "#999" }}>Hakuna miamala ya leo bado.</p>
            ) : (
              <ul style={{ listStyle: "none", padding: 0 }}>
                {Object.entries(todayAmounts).map(([user, amount]) => (
                  <li
                    key={user}
                    style={{
                      borderBottom: "1px solid #444",
                      padding: "8px 0",
                      color: "#eee",
                    }}
                  >
                    <strong>{user}</strong>{" "}
                    <span style={{ fontSize: "0.85em", color: "#aaa" }}>
                      (Aliletwa na: {todayReferrers[user]})
                    </span>
                    <br />
                    {amount.toLocaleString()}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Box mpya ya Bonus */}
          <div
            style={{
              flex: "1",
              background: "#191919",
              padding: "15px",
              borderRadius: "10px",
              maxWidth: "350px",
              color: "#fff",
            }}
          >
            <h3 style={{ color: "#ffcc00" }}>Bonus za Leo (kwa first deposit tu)</h3>
            {Object.keys(todayAmounts).length === 0 ? (
              <p style={{ color: "#999" }}>Hakuna bonus bado.</p>
            ) : (
              <ul style={{ listStyle: "none", padding: 0 }}>
                {Object.entries(todayAmounts).map(([user, amount]) => {
                  // Chukua transactions za leo za user huyu
                  const userTxs = transactions.filter((t) => {
                    const txDate = t.timestamp?.seconds
                      ? new Date(t.timestamp.seconds * 1000)
                      : null;
                    return (
                      t.username === user &&
                      t.status === "success" &&
                      txDate &&
                      txDate >= new Date(new Date().setHours(0, 0, 0, 0))
                    );
                  });

                  // Cheki kama moja ya hizi ni first deposit
                  const hasFirst = userTxs.some((t) => t.position === "first");
                  if (!hasFirst) return null; // Onyesha bonus tu kama first ipo

                  const userBonus = Math.floor(amount * 0.05);
                  const refBonus = Math.floor(amount * 0.1);
                  const referrer = todayReferrers[user];

                  return (
                    <li
                      key={user}
                      style={{
                        borderBottom: "1px solid #444",
                        padding: "10px 0",
                      }}
                    >
                      <p style={{ margin: 0, color: "#00ff99" }}>
                        Ongera <strong>{user}</strong> kuweka{" "}
                        {amount.toLocaleString()} kupata Bonus{" "}
                        {userBonus.toLocaleString()}
                      </p>
                      {referrer && referrer !== "Hakuna" && (
                        <p
                          style={{
                            margin: 0,
                            color: "#66ccff",
                            fontSize: "0.9em",
                          }}
                        >
                          (Kuletwa na <strong>{referrer}</strong> kupata Bonus{" "}
                          {refBonus.toLocaleString()})
                        </p>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>

          {/* Box ya summary zingine */}
          <div style={{ flex: 3 }}>
            <p>
              Idadi ya Depositi Zilizokubaliwa:{" "}
              <strong>{approvedCount}</strong>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Adminchekibonus;